import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService"

import IndexBloc from '../Blocs/IndexBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'

const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.employee_uuid ?? "";
class TableActiveComponent extends Component {
    dataTableBloc = new IndexBloc();

    source
    historyTable = 'historyWorkUnitTableActive' // Nama di tiap tabel harus beda karena akan disimpan di session
    defaultOrder = 'hirarki' // orderBy
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            chartUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            employee_uuid: peg_uuid,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ id: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
        this.dataTableBloc.inactiveChannel?.unsubscribe()
    }

    columns = [
        {
            key: "hirarki",
            text: "Nama Jabatan",
            sortable: true,
            cell: record => {
                return (
                    <Fragment>
                        <label>{record.position_name_tab}</label>
                    </Fragment>
                )
            }
        },
        {
            key: "status_competence_manajerial",
            text: "Manajerial",
            sortable: false,
            className: "text-center",
            width: '7%',
            cell: record => {
                const thisId = record.position_id
                return (
                    <Fragment className="text-center">
                    {(record.status_competence_manajerial>0)?<a href="javascript:void(0)" onClick="toggleModal()"><i className="uil-check-circle" id={"manajerial-"+thisId}></i></a>:<i id={"manajerial-"+thisId} className="uil-times-circle text-danger"></i>}
                        <Tooltip
                            style={{ marginBottom: '2px' }}
                            placement="top" isOpen={this.state["manajerial"+thisId]} target={"manajerial-"+thisId}
                            toggle={() => {
                                this.setState({
                                    ["manajerial"+thisId] : !this.state["manajerial"+thisId]
                                })
                            }}
                        >
                            {((record.status_competence_manajerial>0)?"Data Sudah Diset":"Data Belum Diset")}
                        </Tooltip>
                    </Fragment>
                ) 
            }
        },
        {
            key: "status_competence_teknis",
            text: "Teknis",
            className:"text-center",
            sortable: false,
            width: '7%',
            cell: record => {
                const thisId = record.position_id
                return (
                    <Fragment className="text-center">
                    {(record.status_competence_teknis>0)?<a href="javascript:void(0)" onClick="toggleModal()"><i className="uil-check-circle" id={"teknis-"+thisId}></i></a>:<i id={"teknis-"+thisId} className="uil-times-circle text-danger"></i>}
                        <Tooltip
                            style={{ marginBottom: '2px' }}
                            placement="top" isOpen={this.state["teknis"+thisId]} target={"teknis-"+thisId}
                            toggle={() => {
                                this.setState({
                                    ["teknis"+thisId] : !this.state["teknis"+thisId]
                                })
                            }}
                        >
                            {(record.status_competence_teknis>0)?"Data Sudah Diset":"Data Belum Diset"}
                        </Tooltip>
                    </Fragment>
                ) 
            }
        },
        {
            key: "status_competence_sosio",
            text: "Sosio Kultural",
            className: "text-center",
            sortable: false,
            width: '12%',
            cell: record => {
                const thisId = record.position_id
                return (
                    <Fragment className="text-center">
                    {(record.status_competence_sosio>0)?<a href="javascript:void(0)" onClick="toggleModal()"><i className="uil-check-circle" id={"sosio-"+thisId}></i></a>:<i id={"sosio-"+thisId} className="uil-times-circle text-danger"></i>}
                        <Tooltip
                            style={{ marginBottom: '2px' }}
                            placement="top" isOpen={this.state["sosio"+thisId]} target={"sosio-"+thisId}
                            toggle={() => {
                                this.setState({
                                    ["sosio"+thisId] : !this.state["sosio"+thisId]
                                })
                            }}
                        >
                            {(record.status_competence_sosio>0)?"Data Sudah Diset":"Data Belum Diset"}
                        </Tooltip>
                    </Fragment>
                ) 
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.position_uuid
                return (
                    <Fragment>
                        { accessRole('update') && 
                            <span>
                                <button
                                    className="btn btn-primary btn-sm"
                                    id={"detail-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            detailUuid: record.position_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-align-left"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["detail" + thisId] : !this.state["detail" + thisId]
                                        })
                                    }}
                                >Detail</Tooltip>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            updateUuid: record.position_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId] : !this.state["update" + thisId]
                                        })
                                    }}
                                >Perbaharui</Tooltip>
                            </span> 
                        }
                        
                    </Fragment>
                )
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={"/master/standar_kompetensi.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={"/master/standar_kompetensi.html?update&uuid=" + this.state.updateUuid}/>
                : null }
                { this.state.chartUuid !== null &&
                    <Redirect to={"/master/standar_kompetensi.html?charts&uuid=" + this.state.chartUuid} />
                }
            </>
        )
    }

}

export default TableActiveComponent

